import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import SydTabs from '../../../../../commonDesign/SydTabs'
import DatasourceHeader from '../shared/DatasourceHeader'
import AuditTab from '../shared/AuditTab'
import RestrictionsTab from './RestrictionsTab'
import DetailsTab from './DetailsTab'

const tabOptions = {
  details: {
    label: 'Details'
  },
  restrictions: {
    label: 'Restrictions'
  },
  logs: {
    label: 'Logs'
  }
}
const DEFAULT_TAB = 'details'

function TableDetails ({ datasource }) {
  const [currentTab, setCurrentTab] = useState(DEFAULT_TAB)

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <DatasourceHeader datasource={datasource} />
      </Grid>
      <Grid item xs={12}>
        <SydTabs.Group
          tabOptions={tabOptions}
          defaultValue={DEFAULT_TAB}
          onChange={setCurrentTab}
        >
          <div className='mb-2'>
            <SydTabs.Links />
          </div>
        </SydTabs.Group>
        {currentTab === 'details' ? (
          <DetailsTab datasource={datasource} />
        ) : (currentTab === 'restrictions') ? (
          <RestrictionsTab datasource={datasource} />
        ) : (currentTab === 'logs') ? (
          <AuditTab datasource={datasource} />
        ) : (
          <div>Unknown</div>
        )}
      </Grid>
    </Grid>
  )
}

TableDetails.propTypes = {
  datasource: PropTypes.object
}

export default TableDetails
